import { UIHeading4, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { IHeatIndexScale } from 'shared/types/heatIndex';

import * as styles from './HeatIndexModalContent.css';
import { HeatIndexBodySection } from '../HeatIndexBodySection';
import { HeatIndexDiagram } from '../HeatIndexDiagram';

interface IHeatIndexModalContentProps {
  intervals: IHeatIndexScale[];
}

export const HeatIndexModalContent: React.FC<IHeatIndexModalContentProps> = ({ intervals }) => {
  return (
    <HeatIndexBodySection>
      <UIText1>
        Специалисты замерили теплопотери домов этой серии тепловизором со стороны фасада и торца. Они изучали стены, швы
        между панелями и кирпичами, смотрели на пространства под окнами, где обычно расположены радиаторы. Каждый раз
        учитывали расстояние от подвалов — часто тепло выходит именно там.
      </UIText1>
      <br />
      <UIText1>
        Исследование организовано РОСИЗОЛ — ассоциацией экспертов в сфере теплоизоляции. Всего изучено 300 домов 152
        серий в 15 городах РФ.
      </UIText1>
      <div className={styles['legend']}>
        <UIHeading4>Возможные индексы</UIHeading4>

        {intervals.map(({ range, title }, index) => (
          <div className={styles['heat-index']} key={index}>
            <div className={styles['diagram']}>
              <HeatIndexDiagram key={index} small value={range[1]} title={range.join('-')} />
            </div>
            <UIText1>{title}</UIText1>
          </div>
        ))}
      </div>
    </HeatIndexBodySection>
  );
};
